import React, { useState } from "react";
import House from "../../Assets/images/houso.png";
import RentalSidebar from "./RentalSidebar";
function ActiverentCom({ rental }) {
  const data = rental?.rentals?.[0] || rental;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <RentalSidebar open={open} handleClose={handleClose} rental={data} />
      <div
        onClick={handleOpen}
        className="cursor-pointer border border-gray-200 my-4 rounded-[16px] p-4 flex justify-between items-start bg-white"
      >
        <div className="flex gap-5">
          <img
            src={data?.apartmentClassImagesDTOS?.[0]?.imageUrl}
            alt=""
            className="rounded-[12px] w-[100px] h-[100px] object-cover"
          />
          <div className="py-1 flex gap-1 flex-col">
            <p className="font-bold text-[#1E222B] text-[18px] md:text-[16px] leading-[150%]">
              {data?.apartmentName || ""}
            </p>
            <p className="text-[#1E222B] font-[600] text-[16px] md:text-[16px] leading-[150%]">
              {`(Rooms: ${data?.bedRooms || ""})`}
            </p>
            <p className="font-normal text-[#1E222B] leading-[150%] text-[14px]">
              Rent tenure - {data?.rentTenure || ""}
            </p>
          </div>
        </div>
        <div>
          <p className="text-[#00A859] font-medium leading-[150%] rounded-lg py-1.5 px-6 text-[14px] bg-[#D1F4E0]">
            Active
          </p>
        </div>
      </div>
    </>
  );
}

export default ActiverentCom;
